import type { BaseTranslation } from '../i18n-types';

export const story = {
    swipeInfo: 'Swipe to watch the next video',
    buttonFavorite: 'Add to favorites',
    buttonCall: 'Call',
    buttonUnauthorized: 'Start Call',
    info: {
        publishing: 'Publishing...',
        pendingTitle: 'Pending moderation',
        pendingText: 'It takes up to 24 hours...',
        declineText: 'Story declined. Reason: {deleteReason}. Check <a class="link" href="{terms}" target="_blank">our rules</a>.',
        title: 'Upload your stories',
        text: 'The best way to catch men’s attention is to upload a short video. Try now and reach a broader audience!',
        textMobile: 'Get more favorites by uploading stories.',
        counters: {
            favorites: 'New favorites',
            time: 'Time to delete',
        },
        edit: 'Edit',
    },
    welcomeDialog: {
        title: 'Reach new people by uploading stories',
        text: 'Make a short video for male users and get new contacts and calls',
        ruleTitle: 'Please check these 3 simple rules before start',
        rule1: 'Video must be {seconds:number} seconds or shorter',
        rule2: 'No nudity or other <a class="link" href="{terms}" target="_blank">inappropriate content</a>',
        rule3: 'Video will be deleted after {hours:number} hours',
        button: 'Let’s go',
        agreement: 'I agree to the processing of my data as defined in the <a class="link" href="{privacyLink:string}" target="_blank">Privacy Policy</a> and to the use of my content for promotional purposes as defined in the <a class="link" href="{termsOfUseLink:string}" target="_blank">Agreement</a>.',
    },
    selfInfoDialog: {
        subTitle: 'Please enter the nickname you want to have in the stories and specify what languages you speak.',
        button: 'Upload stories',
    },
    reason: {
        nudity: 'nudity',
        sexualActivity: 'sexual activity',
        sexualDisplay: 'sexual display',
        sextoy: 'sextoy',
        bikini: 'bikini',
        cleavage: 'cleavage',
        lingerie: 'lingerie',
        miniskirt: 'miniskirt',
        maleChest: 'male chest',
        maleUnderwear: 'male underwear',
        erotica: 'erotica',
        suggestive: 'suggestive',
        drugs: 'drugs',
        weapon: 'weapon',
        alcohol: 'alcohol',
        skull: 'skull',
        gore: 'gore',
        minor: 'minor',
        faces: 'faces',
    },
    upload: {
        publish: 'Publish',
        publishing: 'Publishing',
        redo: 'Redo',
        tryAgain: 'Something went wrong while <b>uploading the video</b>. Please try again.',
        error: `Your video cannot be published because it contains {reason: string}. Please record it again with regard to our rules.`,
        errorWithTerms: `Your video cannot be published because it contains {reason: string}. Please record it again with regard to <a class="link" href="{terms}" target="_blank">our rules</a>.`,
        success: 'Your stories was successfully published',
    },
    closeDialog: {
        title: 'Discard media?',
        text: 'In this case the current video draft will not be saved.',
        continue: 'Discard',
    },
    deleteDialog: {
        title: 'Are you sure you want to delete this video?',
        text: 'If you continue, the current video will be deleted forever.',
    },
} satisfies BaseTranslation;
